<template>
	<v-container :key="reloadPageKey">
		<v-card class="elevation-1" color="white">
			<v-card-title class="secondary--text">
				<v-icon large color="secondary" @click="cancelLocumSearch()">mdi-chevron-left</v-icon>
				{{ getLabel('findAProfessional', 'Find a Locum') }}
			</v-card-title>
			<v-card-subtitle class="text-center pb-4">
				{{ this.filteredLocumSearchResults }} / {{ this.unfilteredLocumSearchResults.Count }} registered {{ this.theOfferProfession }}
				{{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'locums') }} match your dates
			</v-card-subtitle>

			<div v-if="!exactMatchesLoaded" align="center" class="my-5">
				<v-progress-circular :indeterminate="true"></v-progress-circular>
			</div>

			<v-divider />
			<v-card-text v-if="exactMatchesLoaded">
				<div v-if="noExactMatches()">
					<v-card flat
						>No {{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'locums') }} found that match your dates. Not to worry, view
						{{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'locums') }} below that have matched the rest of your search criteria.</v-card
					>
				</div>
				<v-card-subtitle class="text-center pt-2" @click="cancelLocumSearch()">
					<v-btn rounded color="orange" outlined dense small><v-icon left>mdi-arrow-left</v-icon>Choose other dates</v-btn>
				</v-card-subtitle>
				<v-pagination v-if="!noExactMatches() && allExactMatches.length > 5" v-model="exactMatchesPage" :length="pageLength"></v-pagination>
				<v-divider v-if="!noExactMatches()" />
				<div v-for="locum in exactMatchesToDisplay" :key="'m-' + locum.id" class="d-flex flex-column mb-3 mt-3">
					<locum-result-card :locum="locum" match-type="Exact"></locum-result-card>
				</div>
			</v-card-text>
		</v-card>

		<!-- Only Load partial matches card if there are any -->
		<v-card v-if="partialMatchesLoaded && filteredPartialResults.length > 0" class="mt-5">
			<v-card-text class="pt-2">
				<div class="pt-5 pb-4">
					<v-card flat
						>These {{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'seekers') }} MAY be available on your selected dates, you can still send a booking
						request or create an open offer that {{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'seekers') }} can apply to.</v-card
					>
				</div>
				<v-divider class="pb-4" />

				<div v-if="!partialMatchesLoaded" align="center" class="my-5">
					<v-progress-circular :indeterminate="true"></v-progress-circular>
				</div>

				<div v-if="partialMatchesLoaded">
					<v-pagination v-model="partialResultsPage" :circle="false" :length="convertedUnfilteredResultsPageLength" :total-visible="7"></v-pagination>

					<div v-for="(locum, index) in filteredPartialResults" :key="index" class="d-flex flex-column mb-3">
						<locum-result-card :locum="locum" match-type="Partial"></locum-result-card>
					</div>
				</div>
			</v-card-text>
			<v-divider />

			<v-card-actions>
				<v-col dense>
					<v-row class="pa-0" dense>
						<v-spacer />
						<v-card-subtitle class="text-center"
							>In a hurry? Create an open offer that {{ getLabel('bookingFlowSearchResultCountProfessionDescriptor', 'seekers') }} can apply to.</v-card-subtitle
						>
						<v-spacer />
					</v-row>

					<v-row class="pa-0" dense>
						<v-spacer />
						<v-btn :disabled="desireCreateOffer" :loading="apiRequest" rounded color="orange" outlined @click="desiresCreateOffer()"
							>Create offer
							<v-icon right>mdi-arrow-right</v-icon>
						</v-btn>
						<v-spacer />
					</v-row>
				</v-col>
			</v-card-actions>
			<v-card-actions v-show="desireCreateOffer">
				<v-col dense>
					<v-row no-gutters>
						<v-col>
							<v-textarea v-model="notes" label="Notes" background-color="#F4F4F4" rounded outlined no-resize></v-textarea>
						</v-col>
					</v-row>
					<v-row class="pa-0" dense>
						<v-spacer />
						<v-btn :loading="apiRequest" rounded color="orange" outlined @click="doCreateOffer()"
							>Submit offer
							<v-icon right>mdi-arrow-right</v-icon>
						</v-btn>
						<v-spacer />
					</v-row>
				</v-col>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
import LocumResultCard from './small cards/LocumResultCard.vue';

import { bus } from '@/main';
import moment from 'moment';

export default {
	name: 'PracticeLocumSearchResults',
	components: { LocumResultCard },
	props: ['data'],
	data: () => ({
		desireCreateOffer: false,
		notes: '',

		API_URL: store.getters.getAPI,

		apiRequest: false,

		partialResultsPage: 1,
		exactMatchesPage: 1,

		reloadPageKey: 0,

		filteredPartialResults: [],
		unfilteredPartialResults: [],
		partialMatchesLoaded: false,

		exactMatchesToDisplay: [],
		allExactMatches: [],
		exactMatchesLoaded: false,

		industryKeys: store.getters.configs.industryKeys,

		IDsToMail: [],
	}),

	computed: {
		...mapGetters('offers', ['offer']),

		convertedUnfilteredResultsPageLength() {
			return Math.ceil(this.unfilteredPartialResults.length / 5);
		},
		pageLength() {
			return Math.ceil(this.filteredLocumSearchResults / 5);
		},
		filteredLocumSearchResults() {
			return this.allExactMatches.length;
		},
		unfilteredLocumSearchResults() {
			return store.getters.getLocumBroadSearch;
		},
		theOfferProfession() {
			return this.offer.profession.toLowerCase().replace('registered', '');
		},
		getPracticeOffer() {
			return this.offer;
		},
		previouslyAppliedLocums() {
			return store.getters.getPracticeLocumsAppliedTo;
		},
		getRequestDates() {
			const { request_dates } = this.offer; //available_dates, start_time, end_time,
			let available_dates = request_dates;
			return available_dates;
			// return available_dates.map(date => {
			// 	const isoStart = moment(`${date} ${start_time}`).format();
			// 	let isoEnd = moment(`${date} ${end_time}`).format();

			// 	const isNightShift = this.isTwoDayShift({ start_time, end_time, date });
			// 	if (isNightShift) {
			// 		isoEnd = moment(isoEnd).add('days', 1).format();
			// 	}

			// 	return {
			// 		date,
			// 		start_time: isoStart,
			// 		end_time: isoEnd,
			// 	};
			// });
		},
	},
	watch: {
		partialResultsPage() {
			this.pageResults('filteredPartialResults', 'unfilteredPartialResults', 'partialResultsPage', 'partialMatchesLoaded');
		},
		exactMatchesPage() {
			this.pageResults('exactMatchesToDisplay', 'allExactMatches', 'exactMatchesPage', 'exactMatchesLoaded');
		},
	},
	mounted() {
		this.practiceoffer = this.offer;
	},
	async created() {
		this.allExactMatches = store.getters.getPracticeLocumSearchResults;
		this.exactMatchesToDisplay = this.allExactMatches.slice(0, 5);
		this.exactMatchesLoaded = true;

		let partialResults = store.getters.getLocumBroadSearch;
		this.setUnfilteredPartialResults(partialResults);

		const initialSlice = this.unfilteredPartialResults.slice(0, 5);
		this.filteredPartialResults = initialSlice;
		this.partialMatchesLoaded = true;

		this.exactMatchesToDisplay.forEach(exactMatch => {
			this.IDsToMail.push(exactMatch.id);
		});

		partialResults.Items.forEach(partialMatch => {
			this.IDsToMail.push(partialMatch.id);
		});
	},
	methods: {
		...mapActions('offers', ['UpsertOffer']),

		setUnfilteredPartialResults(partialResults) {
			partialResults.Items.filter(locum => !(locum.id in partialResults)).forEach(locum => {
				let copy = { ...locum };
				const available_dates = [];
				const booking_requests = [];
				const { date, end_date, start_time, end_time } = this.getPracticeOffer;

				copy = { ...copy, available_dates, booking_requests, date, end_date, start_time, end_time };
				copy.professional = locum;

				if (locum.approved) this.unfilteredPartialResults.push(copy);
			});
		},
		pageResults(pagedLocums, allLocums, page, loader) {
			this[loader] = false;
			const sliceFrom = (this[page] - 1) * 5;
			const sliceTo = sliceFrom + 5;
			this[pagedLocums] = this[allLocums].slice(sliceFrom, sliceTo);
			setTimeout(() => {
				this[loader] = true;
			}, 200);
		},
		desiresCreateOffer() {
			this.notes = this.getPracticeOffer.notes;
			this.desireCreateOffer = true;
		},
		noExactMatches() {
			return this.allExactMatches.length == 0;
		},

		cancelLocumSearch() {
			bus.$emit('change-context', 'practice-locum-search', this.data);
		},

		getMappedSkills(skills) {
			return skills.map(code => ({ code, name: this.industryKeys[code] }));
		},

		isTwoDayShift({ start_time, end_time, date }) {
			let { start, end } = this.getStartEndDates(start_time, end_time, date);
			return moment(start).isAfter(end);
		},

		getStartEndDates(start_time, end_time, date) {
			const start = moment(`${date} ${start_time}`);
			let end = moment(`${date} ${end_time}`);
			return { start, end };
		},

		async doCreateOffer() {
			this.apiRequest = true;

			let payload = this.offer;
			delete payload['update_timestamp'];
			delete payload.company.address['update_timestamp'];

			payload.request_dates = this.getRequestDates;

			payload.notes = this.notes;

			payload.skills = this.getMappedSkills(payload.skills);

			payload.IDsToMail = this.IDsToMail;

			try {
				await this.UpsertOffer(payload);
			} finally {
				this.apiRequest = false;
				// setTimeout(() => {
				bus.$emit('UpdateCalendar');
				// }, 500);
				store.commit('PUSH_NOTIFICATION', { component: 'practice-offer-set', data: ['derpderp'] });
				bus.$emit('change-context', 'practice-dashboard-landing-zone');
			}
		},

		PercentageMatchFor(Locum) {
			let offer = store.getters.getPracticeOffer;
			let countLocumDaysMatched = Locum.map(avail => avail.available_dates.filter(date => offer.available_dates.indexOf(date) > -1).length).reduce((a, b) => a + b, 0);
			return Math.floor((countLocumDaysMatched / offer.available_dates.length) * 100);
		},
	},
};
</script>
